import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/icon/icon_unchecked.png';
import _imports_1 from '@/assets/icon/icon_checked.png';
import _imports_2 from '@/assets/img/user/card/gold_card.png';
import _imports_3 from '@/assets/img/user/card/diamond_card.png';
import _imports_4 from '@/assets/img/user/card/black_card.png';
const _withScopeId = n => (_pushScopeId("data-v-cd904c1a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "exchangeWrapper border-box" };
const _hoisted_2 = { class: "ticketList list m-auto white-bg border-box" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("dt", { class: "font-36 font-w500" }, "选择门票", -1));
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "info flex-1 text-overflow" };
const _hoisted_6 = { class: "ticketName font-32 font-w500" };
const _hoisted_7 = { class: "msg text-overflow font-28" };
const _hoisted_8 = { class: "msg font-28" };
const _hoisted_9 = /*#__PURE__*/ _createTextVNode(" 库存：");
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "radio" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        class: "icon-check unchecked",
        src: _imports_0,
        alt: ""
    }),
    /*#__PURE__*/ _createElementVNode("img", {
        class: "icon-check checked",
        src: _imports_1,
        alt: ""
    })
], -1));
const _hoisted_11 = { class: "ticketList list m-auto white-bg border-box" };
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("dt", { class: "font-36 font-w500" }, "练习卡", -1));
const _hoisted_13 = {
    key: 0,
    class: "goldCard card"
};
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "img" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: _imports_2,
        alt: ""
    })
], -1));
const _hoisted_15 = { class: "cardName font-w500 font-20" };
const _hoisted_16 = {
    key: 1,
    class: "diamCard card"
};
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "img" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: _imports_3,
        alt: ""
    })
], -1));
const _hoisted_18 = { class: "cardName font-w500 font-20" };
const _hoisted_19 = {
    key: 2,
    class: "blackCard card"
};
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "img" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: _imports_4,
        alt: ""
    })
], -1));
const _hoisted_21 = { class: "cardName font-w500 font-20" };
const _hoisted_22 = { class: "cardInfo font-28" };
const _hoisted_23 = { key: 0 };
const _hoisted_24 = { key: 1 };
const _hoisted_25 = { class: "btnWrapper" };
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getExchangeTicket, cardExchange } from '@/api/exercise';
import { Toast } from 'vant';
import { debounce } from 'lodash-es';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const courseId = String(route.params.courseId);
        const ticketId = ref(0);
        const cards = ref([]);
        const tickets = ref([]);
        let nonce = '';
        const getList = () => {
            getExchangeTicket({ courseId }).then((res) => {
                if (res.code == 200) {
                    cards.value = res.data.cards;
                    nonce = res.data.nonce;
                    tickets.value = res.data.tickets;
                }
            });
        };
        getList();
        const selectTicket = (item) => {
            if (item.status === 'DISABLED') {
                Toast('该门票库存不足');
                return;
            }
            ticketId.value = item.ticketDetailId;
        };
        let subFlag = false;
        // 兑换
        const submitOrder = debounce(() => {
            if (!ticketId.value) {
                Toast('请选择门票');
                return;
            }
            if (subFlag) {
                return;
            }
            subFlag = true;
            cardExchange({
                ticketDetailId: ticketId.value,
                nonce
            }).then((res) => {
                subFlag = false;
                if (res.code == 200) {
                    router.replace({
                        path: '/exchange/result/' + courseId
                    });
                }
            });
        }, 300, { leading: true, trailing: false });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("dl", _hoisted_2, [
                    _hoisted_3,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tickets.value, (item) => {
                        return (_openBlock(), _createElementBlock("dd", {
                            class: _normalizeClass(["item flexBox p-20 ig-border1 m-b20", { active: ticketId.value == item.ticketDetailId }]),
                            onClick: _withModifiers(($event) => (selectTicket(item)), ["stop"]),
                            key: item.ticketDetailId + ''
                        }, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, _toDisplayString(item.name), 1),
                                _createElementVNode("div", _hoisted_7, " 消耗：" + _toDisplayString(item.description), 1),
                                _createElementVNode("div", _hoisted_8, [
                                    _hoisted_9,
                                    _createElementVNode("span", {
                                        class: _normalizeClass({ themeColor: item.status == 'DISABLED' })
                                    }, _toDisplayString(item.remain), 3)
                                ])
                            ]),
                            _hoisted_10
                        ], 10, _hoisted_4));
                    }), 128))
                ]),
                _createElementVNode("dl", _hoisted_11, [
                    _hoisted_12,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cards.value, (card) => {
                        return (_openBlock(), _createElementBlock("dd", {
                            class: "item ig-border1 p-20 flexBox m-b20",
                            key: card.cardId
                        }, [
                            (card.level == 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _hoisted_14,
                                    _createElementVNode("div", _hoisted_15, _toDisplayString(card.cardName), 1)
                                ]))
                                : _createCommentVNode("", true),
                            (card.level == 2)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                    _hoisted_17,
                                    _createElementVNode("div", _hoisted_18, _toDisplayString(card.cardName), 1)
                                ]))
                                : _createCommentVNode("", true),
                            (card.level == 3)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _hoisted_20,
                                    _createElementVNode("div", _hoisted_21, _toDisplayString(card.cardName), 1)
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_22, [
                                (card.operationCouponType == 'OPERATION02')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, " 实操券（张）" + _toDisplayString(card.operation02CouponCount), 1))
                                    : _createCommentVNode("", true),
                                (card.operationCouponType == 'OPERATION01')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, " 练习券（张）" + _toDisplayString(card.operation01CouponCount), 1))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", null, "观摩券（张）" + _toDisplayString(card.viewCouponCount), 1)
                            ])
                        ]));
                    }), 128))
                ]),
                _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", {
                        class: _normalizeClass(["submitBtn font-w500 font-28", { disabled: !ticketId.value }]),
                        onClick: _cache[0] || (_cache[0] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_unref(submitOrder) && _unref(submitOrder)(...args)), ["stop"]))
                    }, " 确认兑换 ", 2)
                ])
            ]));
        };
    }
});
